import { CALCULATE_GST_FOR_ROOMS_MODIFIED, FOLIO_FORMAT } from "./helper";

export const mealPlanChangeCalculation = (
  roomPriceStructure,
  roomTypes,
  mealPlan,
  occupancyPlanRate
) => {
  if (!Array.isArray(roomPriceStructure) || !Array.isArray(roomTypes)) return;

  return roomPriceStructure?.map((obj) => {
        const roomType = roomTypes.find(rt=>rt.name === obj.name);
        const defaultOccupancy = roomType?.defaultOccupancy || 2;
        const guestsAllowed = roomType?.guestsAllowed || defaultOccupancy;

        let rate = occupancyPlanRate?.[roomType?._id]?.[mealPlan]?.[defaultOccupancy];
        let extraGuestRate = guestsAllowed > defaultOccupancy ? occupancyPlanRate?.[roomType?._id]?.[mealPlan]?.[defaultOccupancy + 1] - rate : 0;
        
        // Get extraChildRate from meal plan pricing if available
        let extraChildRate;
        if (roomType?.meanPlanBasedPricingEnabled && roomType?.mealPlanPricingDetailsMap?.[mealPlan]) {
          extraChildRate = roomType?.mealPlanPricingDetailsMap?.[mealPlan]?.extraChildPrice || 0;
        } else {
          // Fallback to component-based pricing or 50% of adult rate
          extraChildRate = roomType?.extraChildPricePerPerson || (extraGuestRate * 0.5);
        }
        
        const singleGuestPriceReduction = rate - occupancyPlanRate?.[roomType?._id]?.[mealPlan]?.[1] || 0
        rate = Boolean(rate) ? rate : roomType?.rate;
        return {
          ...obj,
          rate,
          extraGuestRate,
          extraChildRate,
          singleGuestPriceReduction
        };
      }
    )

};


export const bookingPriceCalculation = (
  detailedPriceBreakup = [],
  taxResponse = []
) => {
  let subTotal = 0.0
  let discountTotal = 0.0;
  let roomTaxes = 0.0;
  let roomTotal = 0.0;
  for(let i in detailedPriceBreakup){
    if(detailedPriceBreakup[i] && detailedPriceBreakup[i]. rate){
      const currentRoomTotalPrice = detailedPriceBreakup[i].rate * detailedPriceBreakup[i].count;
      const discountedCurrentRoomTotalPrice = detailedPriceBreakup[i].discountedRate * detailedPriceBreakup[i].count;
      roomTotal += currentRoomTotalPrice;
      subTotal += discountedCurrentRoomTotalPrice;
      roomTaxes += calculateTaxes({amount: discountedCurrentRoomTotalPrice, taxIds:detailedPriceBreakup[i].taxIds, taxResponse
        , price:detailedPriceBreakup[i].discountedRate});
      if(detailedPriceBreakup[i].discountedRate){
        discountTotal += currentRoomTotalPrice - discountedCurrentRoomTotalPrice;
      }
    }
  }
  return {
    roomTotal,
    subTotal, 
    discount: discountTotal,
    totalRoomTax: roomTaxes,
    total: subTotal + roomTaxes
  }
};

const calculateTaxes = ({amount, taxIds, taxResponse, price}) =>{
  const taxPercentage = findTaxPercentage({amount:price, taxIds, taxes:taxResponse});
  return amount * taxPercentage / 100;
}
const priceCalculationTaxInclusive = (
  selectedRoomWTypeAndNum = {},
  roomTypes = [],
  nightsCount = 1,
  discountInfo = {},
  paymentBreakUps = [],
  detailedBreakupRequiredFormat = [],
  taxResponse = []
) => {
  // step to calculate total, subtotal, tax  & discount for inclusive tax room

  // step 1
  // Calculate the Exclusive Price
  // room price / exclusive tax formulla
  // for example room price 2000 and tax 12% => 2000/ 1+ (12/100)

  // step 2
  // Apply the  Discount Proportionally:
  // (Exclusive room price / total exclusive price) / total discount

  // step 3
  // After applying the discounts:
  // roomPriceAfterDiscount =  original room price - discountedRoomPrice

  // step 4
  // Calculate the Tax
  // roomPriceAfterDiscount * Tax Rate /  1+ (12/100)

  if (
    !Object?.keys(selectedRoomWTypeAndNum)?.length ||
    !roomTypes?.length ||
    !detailedBreakupRequiredFormat?.length
  ) {
    return {
      roomTotal: 0,
      subTotal: 0,
      total: 0,
      discount: 0,
      totalRoomTax: 0,
      totalDeposit: 0,
      balanceLeft: 0,
    };
  }
  let roomTotal = 0;
  let roomTotalWithInclusiveTax = 0;
  let originalRoomTotal = 0;
  let discount = 0;
  let totalPaidAmount = 0;
  let totalTax = 0;
  let totalDiscount = 0;
  let subTotal = 0;

  const roomTypeCountMap = {};
  const roomTypePriceMap = {};

  detailedBreakupRequiredFormat.forEach((item) => {
    const roomName = item?.name || item?.type;
    roomTypeCountMap[roomName] = selectedRoomWTypeAndNum[roomName]?.length || 0;
    roomTypePriceMap[roomName] = item?.rate || 0;

    // Calculate total for the room in this loop to avoid a second pass
  });

  const taxObject = CALCULATE_GST_FOR_ROOMS_MODIFIED(
    roomTypeCountMap,
    roomTypes,
    taxResponse
  );

  // calculate room amount
  detailedBreakupRequiredFormat.forEach((item) => {
    const roomName = item?.name || item?.type;
    // Calculate total for the room in this loop to avoid a second pass

    const tax = taxObject?.taxRoomTypeWise[roomName];
    const singleRoomPrice =
      roomTypePriceMap[roomName] * roomTypeCountMap[roomName] * nightsCount;

    const inclusiveTaxFormula = 1 + +tax / 100;
    roomTotalWithInclusiveTax += singleRoomPrice / inclusiveTaxFormula;
    originalRoomTotal += singleRoomPrice;
  });

  // if (discountInfo?.type === "percentage")
  //   discount = (roomTotal * discountInfo?.value) / 100;
  // else discount = parseFloat(discountInfo?.value) || 0;

  if (discountInfo?.type === "percentage") discount = discountInfo?.value;
  else discount = parseFloat(discountInfo?.value) || 0;

  discount = Boolean(discount) ? discount : 0;

  const roomPriceCalculatedBaseOnFlatDiscount = (roomName) => {
    const singleRoomPrice =
      roomTypePriceMap[roomName] * roomTypeCountMap[roomName] * nightsCount;

    const taxRate = taxObject?.taxRoomTypeWise[roomName];

    const inclusiveTaxFormula = 1 + +taxRate / 100;

    let singleRoomDiscount =
      (singleRoomPrice / originalRoomTotal) * +discountInfo?.value;
    singleRoomDiscount = Boolean(singleRoomDiscount) ? singleRoomDiscount : 0;

    // apply the flat discount

    const originalRoomPriceAfterDiscount = singleRoomPrice - singleRoomDiscount; // 4000 - 480 = 3520

    const exclusivePriceAfterDiscount =
      originalRoomPriceAfterDiscount / inclusiveTaxFormula; // 1760 / 1.12 = 1571.43

    const taxAmount =
      originalRoomPriceAfterDiscount - exclusivePriceAfterDiscount;

    const inclusiveDiscount = singleRoomDiscount / inclusiveTaxFormula;

    const roomTotal = exclusivePriceAfterDiscount;
    const discount = inclusiveDiscount;
    const tax = taxAmount;

    return {
      singleRoomTotal: roomTotal,
      singleRoomDiscount: discount,
      singleRoomTax: tax,
    };
  };

  const roomPriceCalculatedBaseOnPerCentageDiscounnt = (roomName) => {
    const originalRoomPrice =
      roomTypePriceMap[roomName] * roomTypeCountMap[roomName] * nightsCount;

    const taxRate = taxObject?.taxRoomTypeWise[roomName];

    const inclusiveTaxFormula = 1 + +taxRate / 100;

    //const roomTotal = singleRoomPrice / inclusiveTaxFormula;

    const roomPriceWithInclusiveTax = originalRoomPrice / inclusiveTaxFormula;

    //  discount calculation on  original room  price

    let discountedRoomPrice = 0;

    discountedRoomPrice =
      roomPriceWithInclusiveTax * (+discountInfo?.value / 100);

    // Price after Discount (Exclusive of Tax)

    const roomPriceAfterDiscounnt =
      roomPriceWithInclusiveTax - discountedRoomPrice;

    // calculate innclusive tax

    const inclusiveTax = roomPriceAfterDiscounnt * (+taxRate / 100);

    const roomTotal = roomPriceAfterDiscounnt;
    const discount = discountedRoomPrice;
    const tax = inclusiveTax;

    return {
      singleRoomTotal: roomTotal,
      singleRoomDiscount: discount,
      singleRoomTax: tax,
    };
  };

  // calculate discount and tax amount
  detailedBreakupRequiredFormat.forEach((item) => {
    const roomName = item?.name || item?.type;

    // Calculate total for the room in this loop to avoid a second pass

    if (discountInfo?.type === "percentage") {
      const { singleRoomTotal, singleRoomDiscount, singleRoomTax } =
        roomPriceCalculatedBaseOnPerCentageDiscounnt(roomName);
      roomTotal += singleRoomTotal + singleRoomDiscount;
      totalDiscount += singleRoomDiscount;
      totalTax += singleRoomTax;
    } else {
      const { singleRoomTotal, singleRoomDiscount, singleRoomTax } =
        roomPriceCalculatedBaseOnFlatDiscount(roomName);

      roomTotal += singleRoomTotal + singleRoomDiscount;
      totalDiscount += singleRoomDiscount;
      totalTax += singleRoomTax;
    }
  });

  // Calculate final room price after discount per room
  const totalRooms = Object.values(roomTypeCountMap)?.reduce(
    (sum, count) => sum + count,
    0
  );

  const discountPerRoom =
    totalRooms > 0 ? discount / totalRooms / nightsCount : 0;

  const roomTypePriceMapAfterDiscount = {};
  for (const key in roomTypeCountMap) {
    roomTypePriceMapAfterDiscount[key] =
      roomTypePriceMap?.[key] - discountPerRoom;
  }

  totalPaidAmount = paymentBreakUps.reduce(
    (sum, payment) => sum + Number(payment.customerPaidAmount || 0),
    0
  );

  subTotal = roomTotal - totalDiscount;
  const total = subTotal + totalTax;
  const balanceLeft = total - totalPaidAmount;

  //const roomTotal

  return {
    roomTotal: roomTotal || 0.0,
    subTotal: subTotal || 0.0,
    total: total || 0.0,
    discount: totalDiscount,
    totalRoomTax: totalTax || 0.0,
    totalDeposit: totalPaidAmount || 0.0,
    balanceLeft: balanceLeft || 0.0,
  };
};

const priceCalculationTaxExclusive = (
  selectedRoomWTypeAndNum = {},
  roomTypes = [],
  nightsCount = 1,
  discountInfo = {},
  paymentBreakUps = [],
  detailedBreakupRequiredFormat = [],
  taxResponse = []
) => {
  if (
    !Object.keys(selectedRoomWTypeAndNum)?.length ||
    !roomTypes?.length ||
    !detailedBreakupRequiredFormat?.length
  ) {
    return {
      roomTotal: 0,
      subTotal: 0,
      total: 0,
      discount: 0,
      totalRoomTax: 0,
      totalDeposit: 0,
      balanceLeft: 0,
    };
  }

  let roomTotal = 0;
  let totalRoomTax = 0;

  const roomTypeCountMap = {};
  const roomTypePriceMap = {};

  // Populate roomTypeCountMap and roomTypePriceMap
  detailedBreakupRequiredFormat.forEach((item) => {
    const roomName = item?.name || item?.type;
    roomTypeCountMap[roomName] =
      selectedRoomWTypeAndNum?.[roomName]?.length || 0;
    roomTypePriceMap[roomName] = item?.rate || 0;
  });

  const totalRooms = Object.values(roomTypeCountMap).reduce(
    (sum, count) => sum + count,
    0
  );

  for (const roomName in roomTypeCountMap) {
    const roomCount = roomTypeCountMap[roomName];
    const roomRate = roomTypePriceMap[roomName];

    roomTotal += roomRate * roomCount * nightsCount;
  }

  const discount =
    discountInfo?.type === "percentage"
      ? (roomTotal * discountInfo?.value) / 100
      : parseFloat(discountInfo?.value) || 0;

  const discountPerRoom =
    totalRooms > 0 ? discount / totalRooms / nightsCount : 0;

  const taxResult = CALCULATE_GST_FOR_ROOMS_MODIFIED(
    selectedRoomWTypeAndNum,
    roomTypes,
    taxResponse
  );

  const taxObject = taxResult?.taxRoomTypeWise || {};

  for (const roomName in roomTypeCountMap) {
    const roomCount = roomTypeCountMap[roomName];
    const roomRate = roomTypePriceMap[roomName];
    const roomRateAfterDiscount = roomRate - discountPerRoom;

    totalRoomTax +=
      (roomRateAfterDiscount *
        roomCount *
        nightsCount *
        (taxObject[roomName] || 0)) /
      100;
  }

  const totalPaidAmount = paymentBreakUps?.reduce(
    (sum, payment) => sum + Number(payment?.customerPaidAmount || 0),
    0
  );

  // Final calculations
  const subTotal = roomTotal - discount;
  const total = subTotal + totalRoomTax;
  const balanceLeft = total - totalPaidAmount;

  return {
    roomTotal: roomTotal || 0.0,
    subTotal: subTotal || 0.0,
    total: total || 0.0,
    discount: discount || 0.0,
    totalRoomTax: totalRoomTax || 0.0,
    totalDeposit: totalPaidAmount || 0.0,
    balanceLeft: balanceLeft || 0.0,
  };
};


export const invoicePriceBreakupCalculation = (priceBreakupObj, taxArray) => {
  const result = priceBreakupCalc([priceBreakupObj], taxArray);

  return {
    taxRate: FOLIO_FORMAT(result?.totalAddOnsTax),
    totalRate: FOLIO_FORMAT(result?.discountedAddOnsTotal),
    baseRate: FOLIO_FORMAT(result?.addOnsTotal - result?.totalAddOnsTax),
  };
};

// Addons Calculation
export const priceBreakupCalc = (addOnsArray, taxArray) => {
  if (!Array.isArray(taxArray) || !Array.isArray(addOnsArray)) {
    return {
      addOnsTotal: 0,
      totalAddOnsTax: 0,

      addOnsDiscountedTotalWithoutTax: 0,
      addOnsTotalWithoutTax: 0,

      addOnsTotalWithCount: 0,
      discountedAddOnsTotalWithCount: 0,
      totalAddOnsTaxWithCount: 0,

      discountedAddOnsTotal: 0,
    };
  }

  let addOnsTotalWithoutTax = 0;
  let addOnsDiscountedTotalWithoutTax = 0;

  let addOnsTotalWithoutTaxWithCount = 0;
  let addOnsDiscountedTotalWithoutTaxWithCount = 0;

  let totalAddOnsTax = 0;
  let totalAddOnsTaxWithCount = 0;

  // Preprocess taxArray into a dictionary for quick lookup
  const taxLookup = taxArray.reduce((acc, taxObj) => {
    acc[taxObj.taxId] = taxObj.taxPercentage;
    return acc;
  }, {});

  addOnsArray?.forEach((Obj) => {
    // Determine current rate (discountedRate, rate, or price)
    let currentRate = Boolean(Obj?.discountedRate)
      ? Obj?.discountedRate
      : Obj?.rate ?? Obj?.price;

    // Determine price without discount for comparison
    let originalRate = Obj?.rate ?? Obj?.price;

    // Count items
    let itemCount = Obj?.count ?? 1;

    // Accumulate totals without tax
    addOnsDiscountedTotalWithoutTax += currentRate;
    addOnsTotalWithoutTax += originalRate;

    addOnsDiscountedTotalWithoutTaxWithCount += currentRate * itemCount;
    addOnsTotalWithoutTaxWithCount += originalRate * itemCount;

    // Calculate the tax for this item based on its taxIds
    const currentObjTaxArray = Obj?.taxIds;
    let itemTaxPercentage = 0;
    currentObjTaxArray?.forEach((taxId) => {
      itemTaxPercentage += taxLookup?.[taxId] ?? 0;
    });

    // Apply the tax percentage to the current item
    const itemTax = (currentRate * itemTaxPercentage) / 100;
    const itemTaxWithCount =
      (currentRate * itemCount * itemTaxPercentage) / 100;

    totalAddOnsTax += itemTax;
    totalAddOnsTaxWithCount += itemTaxWithCount;
  });

  return {
    addOnsTotalWithCount:
      totalAddOnsTaxWithCount + addOnsTotalWithoutTaxWithCount,

    discountedAddOnsTotalWithCount:
      totalAddOnsTaxWithCount + addOnsDiscountedTotalWithoutTaxWithCount,

    totalAddOnsTaxWithCount,

    addOnsTotal: Boolean(addOnsTotalWithoutTax)
      ? totalAddOnsTax + addOnsTotalWithoutTax
      : 0,

    discountedAddOnsTotal: Boolean(addOnsDiscountedTotalWithoutTax)
      ? totalAddOnsTax + addOnsDiscountedTotalWithoutTax
      : 0,

    totalAddOnsTax,
  };
};

export const bookingDetailsAddOnsCalculationV2 = (addOnsArray, taxArray) => {
  if (!Array.isArray(taxArray) || !Array.isArray(addOnsArray)) {
    return {
      baseRate: 0,
      taxRate: 0,
      totalRate: 0,
    };
  }

  let addOnsTotalWithoutTax = 0;
  let totalAddOnsTax = 0;

  // Preprocess taxArray into a dictionary for quick lookup
  const taxLookup = taxArray.reduce((acc, taxObj) => {
    acc[taxObj.taxId] = taxObj.taxPercentage;
    return acc;
  }, {});

  addOnsArray?.forEach((Obj) => {
    let currentRate = Obj?.price ?? 0;
    let itemCount = Obj?.count ?? 1;

    const currentObjTaxArray = Obj?.taxIds;

    let itemTaxPercentage = 0;
    currentObjTaxArray?.forEach((taxId) => {
      itemTaxPercentage += taxLookup?.[taxId] ?? 0;
    });

    const itemTax = (currentRate * itemTaxPercentage * itemCount) / 100;

    addOnsTotalWithoutTax += currentRate * itemCount;
    totalAddOnsTax += itemTax;
  });

  return {
    baseRate: addOnsTotalWithoutTax,
    taxRate: totalAddOnsTax,
    totalRate: addOnsTotalWithoutTax + totalAddOnsTax,
  };
};

export const addOnsCalculation = (addOnsArray, taxResponse) => {
  if (!Array.isArray(taxResponse && addOnsArray)) {
    return {
      addOnCostWithoutTax: 0,
      totalAddOnsTax: 0,
      addOnsTotal: 0,
    };
  }

  // Preprocess taxResponse into a dictionary for quick lookup
  const taxLookup = taxResponse?.reduce((acc, tax) => {
    acc[tax.id] = tax;
    return acc;
  }, {});

  let addOnCostWithoutTax = 0;
  let totalAddOnsTax = 0;

  (addOnsArray || []).forEach((Obj) => {
    const itemCost = Obj.price * Obj.count;
    addOnCostWithoutTax += itemCost;

    const addOnTaxPercentage = addOnTax(Obj.taxIds || [], taxLookup);
    totalAddOnsTax += addOnTaxPercentage * itemCost;
  });

  return {
    addOnCostWithoutTax: Boolean(addOnCostWithoutTax) ? addOnCostWithoutTax : 0,
    totalAddOnsTax: Boolean(totalAddOnsTax) ? totalAddOnsTax : 0,
    addOnsTotal:
      (Boolean(addOnCostWithoutTax) ? addOnCostWithoutTax : 0) +
      (Boolean(totalAddOnsTax) ? totalAddOnsTax : 0),
  };
};

export const addOnTax = (taxArray = [], taxLookup = {}) => {
  if (!Array.isArray(taxArray) || !taxArray.length) return 0;

  let cumulativeTax = taxArray?.reduce((total, taxId) => {
    const tax = taxLookup?.[taxId];
    return tax ? total + +tax.taxPercentage : total;
  }, 0);

  return cumulativeTax > 0 ? cumulativeTax / 100 : 0;
};

export const buildDetailedPriceBreakup = (
  currentPriceBreakup,
  rooms,
  detailedRoomInthisBooking,
  nightsCount,
  isOTABooking,
  complimentaryRoomIds
) => {
  let updatedPriceBrekup = isOTABooking
    ? multipleObjectFromSameObjForOTABooking(
        currentPriceBreakup?.map((Obj) => {
          return {
            ...Obj,
            count: Obj?.count / nightsCount,
          };
        })
      )
    : currentPriceBreakup;
  let localDetailedPriceBrekup = [];
  currentPriceBreakup.forEach(pb=>{
  let occupancy = pb.occupancy;
  // find count of rooms in room type, 
  // check if price is not zero, filter to keep only non complimentary rooms
  // 
  const roomWiseOccupancy = {};
  const roomsOfRoomType = detailedRoomInthisBooking?.filter(r=> r.type === pb.type);
  const roomTypeObj = rooms?.find(r=> r.name === pb.type);
  const defaultOccupancy = roomTypeObj?.defaultOccupancy || 2;
  const maxGuestsAllowed = roomTypeObj?.guestsAllowed || 3;
  for(const i in roomsOfRoomType){
    const room = roomsOfRoomType[i];
      roomWiseOccupancy[room.id] = 1
    occupancy--;
  }
  if(occupancy > 0){
    for(const i in roomsOfRoomType){
      if(occupancy <= 0){
        break;
      }
      const room = roomsOfRoomType[i];
      const increamentInOccupancy = occupancy < defaultOccupancy - roomWiseOccupancy[room.id] ? occupancy : roomWiseOccupancy[room.id] - defaultOccupancy;
      roomWiseOccupancy[room.id] += increamentInOccupancy
      occupancy -= increamentInOccupancy;
    }
    if(occupancy > 0){
      for(const i in roomsOfRoomType){
        if(occupancy <= 0){
          break;
        }
        const room = roomsOfRoomType[i];
        const increamentInOccupancy = occupancy < maxGuestsAllowed - roomWiseOccupancy[room.id] ? occupancy : roomWiseOccupancy[room.id] - maxGuestsAllowed;
        roomWiseOccupancy[room.id] += increamentInOccupancy
        occupancy -= increamentInOccupancy;
      }
    }
  }
})



  return localDetailedPriceBrekup
};

const multipleObjectFromSameObjForOTABooking = (data) => {
  return data.flatMap((item) => {
    // Create an array of 'count' length with the same object repeated
    return Array.from({ length: item.count }, () => ({
      ...item,
      count: 1, // Set count to 1 for each new object
    }));
  });
};

export const fallBackRoomRate = (roomObj, mealPlan) => {
  let defaultOccupancy = +roomObj?.defaultOccupancy;
  let breakfastPrice = +roomObj?.breakfastPrice || 0; // Assuming mealPrice has a breakfast property
  let lunchPrice = +roomObj?.mealPrice || 0; // Assuming mealPrice has a lunch property
  let dinnerPrice = +roomObj?.mealPrice || 0; // Assuming mealPrice has a dinner property
  let rate = +roomObj?.rate || 0; // Default to 0 if rate is undefined
  let result;

  // Calculate based on meal plan
  if (mealPlan === "EP") {
    return +rate; // Only the room rate
  } else if (mealPlan === "CP") {
    result = rate + breakfastPrice * defaultOccupancy; // Room rate + cost of breakfast
    return +result;
  } else if (mealPlan === "MAP") {
    result = rate + (breakfastPrice + lunchPrice) * defaultOccupancy; // Room rate + breakfast + lunch
    return +result;
  } else if (mealPlan === "AP") {
    result =
      rate + (breakfastPrice + lunchPrice + dinnerPrice) * defaultOccupancy; // Room rate + breakfast + lunch + dinner
    return +result;
  } else {
    return null; // Return null if the meal plan is not recognized
  }
};

export const findTaxPercentage = ({amount, taxes, taxIds}) => {
  let taxPercentage = 0;

    for(let i in taxes){
      let {minPrice,maxPrice} = taxes[i];
      if(!minPrice){
        minPrice = 0;
      }
      if(!maxPrice) {
        maxPrice = 10000000.0;
      }
      if(taxIds && taxes[i] && taxes[i].id && taxIds.includes(taxes[i].id)
        && amount >= minPrice && amount < maxPrice
      ){
        taxPercentage += taxes[i].taxPercentage ? taxes[i].taxPercentage : 0;
      }
    }
  return taxPercentage;
}

export const calculatepaymentReceivedInCreateBooking = (paymentBreakups) =>{
  if(paymentBreakups && paymentBreakups.length > 0){
    let paymentAmount = 0;
    for(let i in paymentBreakups){
      if(paymentBreakups[i] && paymentBreakups[i].customerPaidAmount){
        paymentAmount += paymentBreakups[i].customerPaidAmount;
      }
    }
    return paymentAmount;
  }
  return 0
}



export const buildPriceBreakup = (detailedPriceBreakup) => {
  let requiredPriceBrekupForDiscount = [];
  /**
   * {
          name: roomTypeName,
          id: room.id,
          count: nightsCount,
          occupancy: room.occupancy,
          rate: price,
          baseRate: findBaseRate({roomPriceStructure, roomTypeName, price}),
          taxIds: room.taxIds
     }
   */
  for(let i in detailedPriceBreakup){
    let priceBreakUpEntry = requiredPriceBrekupForDiscount.find(pb => pb && pb.rate === detailedPriceBreakup[i].rate && pb.type === detailedPriceBreakup[i].name);
    if(!priceBreakUpEntry){
      priceBreakUpEntry = {
      discountedRate: detailedPriceBreakup[i].discountedRate || 0,
      count: detailedPriceBreakup[i].count || 1,
      baseRate: detailedPriceBreakup[i].baseRate || 0,
      type: detailedPriceBreakup[i].name,
      rate: detailedPriceBreakup[i].rate || 0,
      taxIds: detailedPriceBreakup[i].taxIds || [],
      occupancy: detailedPriceBreakup[i].occupancy || 1,
      adults: detailedPriceBreakup[i].adults || 0,
      children: detailedPriceBreakup[i].children || 0,
      }
      requiredPriceBrekupForDiscount.push(priceBreakUpEntry);
    } else{
      priceBreakUpEntry.count += detailedPriceBreakup[i].count;
      priceBreakUpEntry.occupancy += detailedPriceBreakup[i].occupancy;
      priceBreakUpEntry.adults += detailedPriceBreakup[i].adults || 0;
      priceBreakUpEntry.children += detailedPriceBreakup[i].children || 0;
    }
  }
  return requiredPriceBrekupForDiscount;

}

export const generateDetailedPriceBreakupForEditBookings = ({priceBreakup, noOfNights, complimentaryRoomIds = [], detailedRoomInthisBooking, roomTypes})=>{

//1. In the room types price breakup data, put in the room count, also check if base price, price and discounted price are of one room only
  if(!priceBreakup || priceBreakup.length == 0) {
    return [];
  }
  let roomsToBeAllotted = JSON.parse(JSON.stringify(detailedRoomInthisBooking));
  const priceBreakupWithRoomIdsAndRoomCount = priceBreakup?.map(pbe=>{
    const newEntry = JSON.parse(JSON.stringify(pbe));
    newEntry['roomsOccupied'] = newEntry.count / noOfNights;
    return newEntry;
  })


//2. Assign complimentary room ids in the price breakup detail that have zero price
  for(let i in complimentaryRoomIds)  {
    const roomId = complimentaryRoomIds[i];
    const room = detailedRoomInthisBooking.find(r=> r.id === roomId);
    const rpbe = priceBreakupWithRoomIdsAndRoomCount.find(pbe=>pbe.type === room.type && pbe.rate == 0 && pbe.roomsOccupied.length > pbe.roomIds.length);
    if(!rpbe.roomIds){
      rpbe.roomIds = [];
    }
    rpbe.roomTypeId = room.roomTypeId;
    rpbe.roomIds.push(roomId)
    roomsToBeAllotted = roomsToBeAllotted.filter(r=> r.id !== roomId);
  }
//3. Assign rest of the room ids in the relevant breakup details
  for(let i in roomsToBeAllotted) {
    const room = roomsToBeAllotted[i];
    const rpbe = priceBreakupWithRoomIdsAndRoomCount.find(pbe=>pbe.type === room.type && (!pbe.roomIds || pbe.roomsOccupied > pbe.roomIds.length));
    if(!rpbe){
      continue;
    }
    if(!rpbe['roomIds']){
      rpbe['roomIds'] = [];
    }
    rpbe['roomIds'].push(room.id);
    rpbe.roomTypeId = room.roomTypeId;
  }
//4. For each room type in each price breakup detail, prepare list of detailed price breakup for those room types, assign base rate, rate, discounted rate roomtype id, room type name and set occupancy as zero
  const detailedPriceBreakup = [];
  for(let i in priceBreakupWithRoomIdsAndRoomCount){
    const pbe = priceBreakupWithRoomIdsAndRoomCount[i];
    for(const j in pbe['roomIds']){
      const roomId = pbe['roomIds'][j];
      // Find the room details to get room number
      const roomDetails = detailedRoomInthisBooking.find(r => r.id === roomId);
      detailedPriceBreakup.push({
        id:roomId,
        name:pbe.type,
        roomNumber: roomDetails?.name,
        roomTypeId:pbe.roomTypeId,
        count:noOfNights,
        rate:pbe.rate,
        baseRate:pbe.baseRate,
        discountedRate: pbe.discountedRate,
        occupancy:0,
        taxIds:pbe.taxIds
      })
    }
  }

//5. Assign occupancy in each room of the room type, by first filling one guest in each room, then, filling default occupancy in each and then filling max guests in each
  for(let i in priceBreakupWithRoomIdsAndRoomCount) {
    const pbe = priceBreakupWithRoomIdsAndRoomCount[i];
    const roomType = roomTypes.find(r=>r.name === pbe.type);
    const detailedBreakupListForCurrentPBE = detailedPriceBreakup.filter(dpbe=> pbe && pbe.roomIds && pbe.roomIds.includes(dpbe.id));
    for(const j in detailedBreakupListForCurrentPBE) {
      const dpbe = detailedBreakupListForCurrentPBE[j];
      dpbe.occupancy = 1;
      pbe.occupancy--;
      if(pbe.occupancy <= 0){
        break;
      }
    }
    if(pbe.occupancy > 0){
      for(const j in detailedBreakupListForCurrentPBE) {
        const dpbe = detailedBreakupListForCurrentPBE[j];
        const increament = roomType.defaultOccupancy - dpbe.occupancy < pbe.occupancy ? roomType.defaultOccupancy - dpbe.occupancy :  pbe.occupancy;
        dpbe.occupancy += increament;
        pbe.occupancy -= increament;
        if(pbe.occupancy <= 0){
          break;
        }
      }
      if(pbe.occupancy > 0){
        for(const j in detailedBreakupListForCurrentPBE) {
          const dpbe = detailedBreakupListForCurrentPBE[j];
          const increament = roomType.defaultOccupancy - dpbe.maxGuestsAllowed < pbe.occupancy ? roomType.maxGuestsAllowed - dpbe.occupancy :  pbe.occupancy;
          dpbe.occupancy += increament;
          pbe.occupancy -= increament;
          if(pbe.occupancy <= 0){
            break;
          }
        } 
      }
    }
  }
  for(let dpbe of detailedPriceBreakup){
    const roomType = roomTypes.find(r=>r.name === dpbe?.name);
    const defaultOccupancy = roomType?.defaultOccupancy || 2;
    const roomOccupancy = dpbe?.occupancy || 2;
    if(roomOccupancy == 1){
      dpbe.singleGuestReductionRate = dpbe.baseRate - dpbe.rate;
    } else if (roomOccupancy > defaultOccupancy){
      const diffOccupancy = roomOccupancy - defaultOccupancy; 
      dpbe.extraGuestRate = (dpbe.rate - dpbe.baseRate) / diffOccupancy;
      dpbe.extraAdultRate = dpbe.extraGuestRate;
    }
  }
  return detailedPriceBreakup;
}